import React from "react";

import { Header } from "../../internal/Header/Header";

const Index = ({ children }) => {
  return <Header>{children}</Header>;
};

export default Index;
